export default __webpack_public_path__ + "static/media/Tomato.be6f8ead.jpg";